import React, { Component, Fragment, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";
import Loading from "./containers/Loading";
import ConfirmReloadDialog from "./ConfirmReloadDialog";
import "react-toastify/dist/ReactToastify.css";
import CustomerReport from "./containers/report/customer/hoc";
import CustomerFirst from "./containers/report/customer/customerFirst";
import PlaySound from "./containers/manage/PlaySound";
import STracking from "./containers/operations/STrack";
import TrackAuth from "./containers/TrackingModule/TrackAuth";
import CustomerTrackView from "./containers/TrackingModule/CustomerTrackView";
import "./../src/containers/CustomerSection/CustomerBookingTracking/customerBooking.css"
import CustomerTrackMobileView from "./containers/TrackingModule/CustomerTrackMobileView";
import CustomerTrackLogsDetails from "./containers/CustomerSection/CustomerBookingTracking/CustomerTrackLogsDetails";
import PaymentGateWaySuccess from "./Components/PaymentGateWay/PaymentGateWaySuccess";
import ReactGA4 from "react-ga4";
import { subscriptionNotification } from "./subscriptionNotification";
import { initGA4 } from "./anaylytics/GoogleAnalytics";
import TriggerExample from "./googleTagManager/TagManager";
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-WXPKHMBM',
};
TagManager.initialize(tagManagerArgs);
// const asyncLogin = Loadable({
//   loader: () => import("./containers/Login/Login"),
//   loading: Loading,
// });
const asyncLogin = React.lazy(() => import("./containers/Login/Login"))
const asyncChangePassword = Loadable({
  loader: () => import("./containers/Login/ChangePassword"),
  loading: Loading,
});

// const asyncForgotPassword = Loadable({
//   loader: () => import("./containers/Login/ForgotPassword"),
//   loading: Loading,
// });
const asyncForgotPassword = React.lazy(() =>import("./containers/Login/ForgotPassword"))

// const asyncCustomerLogin = Loadable({
//   loader: () => import("./containers/Login/CustomerLogin"),
//   loading: Loading,
// });
const asyncCustomerLogin = React.lazy(() =>import("./containers/Login/CustomerLogin"))

// const asyncCustomerChangePassword = Loadable({
//   loader: () => import("./containers/Login/CustomerChangePassword"),
//   loading: Loading,
// });
const asyncCustomerChangePassword = React.lazy(() =>import("./containers/Login/CustomerChangePassword"))

// const asyncCustomerForgotPassword = Loadable({
//   loader: () => import("./containers/Login/CustomerForgotPassword"),
//   loading: Loading,
// });
const asyncCustomerForgotPassword = React.lazy(() =>import("./containers/Login/CustomerForgotPassword"))

// const asyncDashBoard = Loadable({
//   loader: () => import("./containers/DashBoard"),
//   loading: Loading,
// });
const asyncDashBoard = React.lazy(() =>import("./containers/DashBoard"))

// const asyncCustomerDashBoard = Loadable({
//   loader: () => import("./containers/CustomerDashboard"),
//   loading: Loading,
// });
const asyncCustomerDashBoard = React.lazy(() =>import("./containers/CustomerDashboard"))

// const asyncTrack = Loadable({
//   loader: () => import("./containers/CustomerTracking/customerTrack"),
//   loading: Loading,
// });
const asyncTrack = React.lazy(() =>import("./containers/CustomerTracking/customerTrack"))

// const Home = Loadable({
//   loader: () => import("./containers/web/index"),
//   loading: Loading,
// });
const Home = React.lazy(() =>import("./containers/web/index"))

const AsyncDriverDashBoard = React.lazy(()=>import("./containers/DriverDashboard"))
class App extends Component {
  requestNotification = async () => {
    const notification = await Notification.requestPermission()
  
    if(notification === 'granted'){
      // const token = await getToken(messaging,{vapidKey:"BBLbfdSNjhA7ykGx3RDd1-OaBKoqE_k5PkJ1_ZZgNb_s9xzHxm3bUHAL9X5x4KUbDzgSaXQg01OXlxhvSG7nJe4"})
      subscriptionNotification()
    }
    else if(notification === 'denied'){
      alert("you deinied notification permission")
      // unsubscribeFromFCM()
    }
    else{
      // unsubscribeFromFCM()
    }
  }
  componentWillUnmount() {
    console.log("I will unmount");
    sessionStorage.removeItem("kabra:token");
  }

  componentDidMount(): void {
    this.requestNotification()
  }
 
  render() {
    return (
      <Fragment>
            <Suspense fallback={<div>Loading...</div>}>
            {/* <AppShell/> */}
        <Router>
          <Switch>
            <Route path="/login" exact component={asyncLogin} />
            <Route
              path="/login/changePassword"
              component={asyncChangePassword}
            />
            <Route
              path="/login/forgotPassword"
              component={asyncForgotPassword}
            />
            <Route path="/customerLogin" exact component={asyncCustomerLogin} />
            <Route
              path="/customerLogin/changePassword"
              component={asyncCustomerChangePassword}
            />
            <Route
              path="/customerLogin/forgotPassword"
              component={asyncCustomerForgotPassword}
            />
            <Route
              path="/customerDashboard"
              component={asyncCustomerDashBoard}
            />
            <Route
              path="/driverDashboard"
              component={AsyncDriverDashBoard}
            />
            <Route path="/dashboard/" component={asyncDashBoard} />
            <Route path="/track/:docketNumber([^]*)" component={asyncTrack} />
            <Route path="/customer/report" component={CustomerReport} />
            <Route path={`/sTrack/:trackingCode`} component={STracking} />
            <Route path={`/pTrack/:trackingCode`} component={STracking} />
            <Route path="/c/:customerId" component={CustomerFirst} />
            <Route path="/TempTracking" component={TrackAuth} />
            <Route path="/Customer-track/:trackingCode" component={TrackAuth} />
            <Route path="/Customer-track" component={CustomerTrackView} />
            <Route path="/tracking" component={TrackAuth} />
            <Route path={`/detailedLogs`} component={CustomerTrackLogsDetails} />
            <Route path={`/Customer-trackmobile`} component={CustomerTrackMobileView}/>
            <Route path={`/TagManager`} component={TriggerExample}/>
            <Route
                  path={`/paymentSuccess`}
                  component={PaymentGateWaySuccess}
                />
            <Route path="*" component={Home} />
          </Switch>
        </Router>
        </Suspense>
        <ConfirmReloadDialog />
        <PlaySound />
      </Fragment>
    );
  }
}

export default App;
